import React, { useEffect, useState } from "react";

const YesNoOrField = ({ index }) => {
  const [value, setValue] = useState("Ja");

  useEffect(() => {
    localStorage.setItem("gewerksübergreifend" + index, JSON.stringify(value));
  }, [value, index]);

  const handleOptionChange = (e) => {
    const selectedValue = e.target.value;
    setValue(selectedValue);
  };

  const handleReset = () => {
    setValue("");
  };

  return (
    <div className="card" style={{ marginTop: 10, padding: 10 }}>
      <label>{"Gewerksübergreifend"}</label>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          value={"Ja"}
          name={"gewerksübergreifend" + index}
          checked={value === "Ja"}
          onChange={handleOptionChange}
        />
        <label className="form-check-label">Ja</label>
      </div>
      <div className="form-check">
        <input
          className="form-check-input"
          type="radio"
          value={"Nein"}
          name={"gewerksübergreifend" + index}
          checked={value === "Nein"}
          onChange={handleOptionChange}
        />
        <label className="form-check-label">Nein</label>
      </div>
    </div>
  );
};

export default YesNoOrField;
